import { Typography, Divider } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const SettingsArea = ({ text, children }) => {
  const theme = useTheme()

  return (
    <div>
      <Typography
        variant="h2"
        sx={{
          color: theme.palette.primary.main,
          textAlign: 'left', // Left-align the text
          pt: 4,
        }}
      >
        {text}
      </Typography>
      <Divider
        sx={{
          marginTop: 2,
          marginBottom: 3,
          backgroundColor: theme.palette.primary.main,
        }}
      />
      {children}
    </div>
  )
}

export default SettingsArea
